import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useHistory } from "react-router";
import styles from "./style.module.css";
import RoundedGainfulButton from "Root/profile/components/common/RoundedGainfulButton";
const AccountEditSubscription = () => {
    const history = useHistory();
    const goToSubscription = () => history.push("/app/subscription");
    return (_jsx("div", { className: styles.account_edit_subscription_mob, children: _jsx(RoundedGainfulButton, { dataAttr: "home-edit-your-subscription-button", label: "Edit your subscription", onClick: goToSubscription }) }));
};
export default AccountEditSubscription;
